import React, {useState, useRef, useEffect} from "react";
import { useLocation } from 'react-router-dom'; 
import Menu from "../../../../components/layout/menu/index";
import BuyerCardAdmin from "../../../../components/card/buyerCardAdmin";
import {getBuyersChart, postBuyersChart} from "../../../../client/buyers/index";
import SaveButton from "../../../../components/forms/saveButton"
import CancelButton from "../../../../components/forms/cancelButton"
import ModalDelete from "../../../../components/shared/modals/modalDelete";
import { getUsers } from "../../../../client/users/index"
import BuyerForm from "../../../../components/forms/buyersForm/buyerForm";
import buyers from "../../../../assets/images/icons/buyers/buyers.svg"
import buyersList from "../../../../assets/images/icons/buyers/buyersList.svg"
import BuyersGroup from "./buyersGroup";
import { getAreasList } from "../../../../client/areas";
import ModalAlertWarning from "../../../../components/shared/modals/modalAlertWarning";
import ModalSuccess from "../../../../components/shared/modals/modalSuccess";
import { 
  DndContext, 
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';

export default function BuyersAdmin() {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [chartData, setChartData] = useState({users: [], areas: []});
  const [loading, setLoading] = useState(true);

  const [activeSection, setActiveSection] = useState('buyers'); 

  const [editedUsers, setEditedUsers] = useState([]);
  const [originalUsers, setOriginalUsers] = useState([]);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [activeForms, setActiveForms] = useState([]); 
  const [newUser, setNewUser] = useState({});
  const [userSuggestions, setUserSuggestions] = useState({});

  const [originalChartData, setOriginalChartData] = useState({users: [], areas: []});
  const [areaSuggestions, setAreaSuggestions] = useState({});
  const [allAreas, setAllAreas] = useState([]);
  const [showAreaWarning, setShowAreaWarning] = useState(false);
  const [warningMessage, setWarningMessage] = useState('');
  const [phantomColumns, setPhantomColumns] = useState(1);
  const [deletedAreas, setDeletedAreas] = useState([]);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const [isSending, setIsSending] = useState(false);
const [isDragging, setIsDragging] = useState(false);
const [dragPosition, setDragPosition] = useState(null);
const [dragOverInfo, setDragOverInfo] = useState({ column: null, position: null });

const [scrollPosition, setScrollPosition] = useState(0);
const containerRef = useRef(null);
const topScrollRef = useRef(null);

const [newCategories, setNewCategories] = useState([]);

  const [showImageError, setShowImageError] = useState(false);
  const [imageErrorMessage, setImageErrorMessage] = useState('');
const initialCentered = useRef(false);

const [resetEditingFlag, setResetEditingFlag] = useState(false);

const handleScroll = (e) => {
  const container = e.target;
  setScrollPosition(container.scrollLeft);
  if (topScrollRef.current) {
    topScrollRef.current.scrollLeft = container.scrollLeft;
  }
};

const handleTopScroll = (e) => {
  const topScroll = e.target;
  if (containerRef.current) {
    containerRef.current.scrollLeft = topScroll.scrollLeft;
  }
};

  useEffect(() => {
    if (location.state?.showBuyersGroupSection) {
      setActiveSection('buyersList');
      
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);


  
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5, 
      },
    }),
    useSensor(KeyboardSensor) 
  );

const styles = `
  [data-dragging="true"] {
    transform: scale(1.05);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
    opacity: 1;
    z-index: 1000;
    cursor: grabbing;
    transition: transform 0.1s ease, box-shadow 0.1s ease;
    background-color: white;
    border: 2px solid #184A7D;
  }
  
  .drop-zone-active {
    background-color: rgba(24, 74, 125, 0.1);
    outline: 2px dashed #184A7D;
    min-height: 100px;
    transition: background-color 0.2s ease;
  }
  
.drag-indicator {
    position: fixed;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #184A7D;
    color: white;
    padding: 8px 16px;
    border-radius: 4px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.2);
    z-index: 9999;
    display: flex;
    align-items: center;
    gap: 8px;
  }

.drop-preview {
    position: absolute;
    width: 100%;
    height: 4px;
    background-color: #184A7D;
    z-index: 999;
  }
  
  .drop-preview-top {
    top: 0;
  }
  
  .drop-preview-bottom {
    bottom: 0;
  }
  
  .sortable-item {
    transition: transform 0.2s ease;
  }
`;

const handleDragStart = (event) => {
  const { active } = event;
  document.body.style.cursor = 'grabbing';
  document.body.style.userSelect = 'none';
  setIsDragging(true);
  
  const activeUser = editedUsers.find(u => u.id === active.id);

  if (activeUser) {

    
    setDragPosition({
      x: activeUser.x_position,
      y: activeUser.y_position
    });
  }

  const activeElement = document.querySelector(`[data-id="${active.id}"]`);
  if (activeElement) {
    activeElement.classList.add('dragging-active');
  }
};

const handleDragEnd = (event) => {
  editedUsers.forEach(user => {
  });
  
  const { active, over } = event;
  setIsDragging(false);
  document.body.style.cursor = '';
  document.body.style.userSelect = '';

  if (!over) {
    return;
  }

  const activeUser = editedUsers.find(u => u.id === active.id);
  if (!activeUser) {
    console.error("Active user not found");
    return;
  }

  const { column: targetColumn, position: targetY } = dragOverInfo;


  let updatedUsers = editedUsers.filter(u => u.id !== active.id);

  updatedUsers.push({
    ...activeUser,
    x_position: targetColumn,
    y_position: targetY
  });

  updatedUsers = normalizePositions(updatedUsers);


  setEditedUsers(updatedUsers);
  setDragOverInfo({ column: null, position: null });
};

const normalizePositions = (users) => {
  const columns = {};
  users.forEach(user => {
    if (user.y_position <= -2 && !user.deletedUser) {
      if (!columns[user.x_position]) columns[user.x_position] = [];
      columns[user.x_position].push(user);
    }
  });

  const normalizedUsers = users.filter(u => u.y_position > -2 || u.deletedUser);
  
  Object.entries(columns).forEach(([x, columnUsers]) => {
    columnUsers.sort((a, b) => a.y_position - b.y_position);
    
    columnUsers.forEach((user, index) => {
      normalizedUsers.push({
        ...user,
        y_position: -2 - index
      });
    });
  });

  return normalizedUsers;
};

const normalizeColumnPositions = (users) => {
  const usersByColumn = {};
  users.forEach(user => {
    if (user.y_position <= -2 && !user.deletedUser) {
      if (!usersByColumn[user.x_position]) {
        usersByColumn[user.x_position] = [];
      }
      usersByColumn[user.x_position].push(user);
    }
  });

  const normalizedUsers = users.filter(u => u.y_position > -2 || u.deletedUser);
  
  Object.entries(usersByColumn).forEach(([x, columnUsers]) => {
    columnUsers.sort((a, b) => b.y_position - a.y_position);
    
    columnUsers.forEach((user, index) => {
      normalizedUsers.push({
        ...user,
        y_position: -2 - index
      });
    });
  });

  return normalizedUsers;
};

const handleDragOver = (event) => {
  const { active, over } = event;
  
  if (!over) {
    setDragOverInfo({ column: null, position: null });
    return;
  }


  let column, position;
  
  if (over.data?.current?.type === 'buyer') {
    const overUser = editedUsers.find(u => u.id === over.id);
    if (!overUser) return;
    column = overUser.x_position;
    position = overUser.y_position;
  } else if (over.data?.current?.type === 'column') {
    column = over.data.current.x_position;
    const columnRect = over.rect.current;
    const relativePosition = (event.activatorEvent.clientY - columnRect.top) / columnRect.height;
    
    const usersInColumn = editedUsers.filter(u => 
      u.x_position === column && 
      u.y_position <= -2 && 
      !u.deletedUser
    ).sort((a, b) => a.y_position - b.y_position);
    
    if (usersInColumn.length === 0) {
      position = -2;
    } else {
      const index = Math.floor(relativePosition * usersInColumn.length);
      position = index < usersInColumn.length ? 
        usersInColumn[index].y_position : 
        usersInColumn[usersInColumn.length - 1].y_position - 1;
    }
  }


  setDragOverInfo({ column, position });
  
  document.querySelectorAll('.drop-zone-active').forEach(el => {
    el.classList.remove('drop-zone-active');
  });
  
  const columnElement = document.querySelector(`[data-column="${column}"]`);
  if (columnElement) {
    columnElement.classList.add('drop-zone-active');
    
    const previewElement = document.createElement('div');
    previewElement.className = 'drop-preview';
    previewElement.style.top = `${position}px`; 
    columnElement.appendChild(previewElement);
    
    setTimeout(() => {
      if (previewElement.parentNode) {
        previewElement.parentNode.removeChild(previewElement);
      }
    }, 100);
  }
};

  const handleAreaSelection = (col, area) => {
    const isDuplicate = chartData.areas.some(a => 
      a.name === area.name && a.x_position !== col && a.name.trim() !== ""
    );

    if (isDuplicate) {
      setWarningMessage(`La categoría "${area.name}" ya está en uso. Por favor seleccione otra.`);
      setShowAreaWarning(true);
      
      const updatedAreas = chartData.areas.map(a => 
        a.x_position === col ? {...a, name: ''} : a
      );
      setChartData({...chartData, areas: updatedAreas});
      
      setAreaSuggestions(prev => ({ ...prev, [col]: [] }));
      return;
    }


    const updatedAreas = chartData.areas.map(a => 
      a.x_position === col ? {...a, name: area.name, id: area.id} : a
    );
    setChartData({...chartData, areas: updatedAreas});
    setAreaSuggestions(prev => ({ ...prev, [col]: [] }));
  };

  const searchAreas = async (query, col) => {
    try {
      if (!allAreas.length) {
        const response = await getAreasList();
        setAllAreas(response.data);
      }
      
      const filtered = allAreas.filter(area => 
        area.name.toLowerCase().includes(query.toLowerCase())
      );
      setAreaSuggestions(prev => ({ ...prev, [col]: filtered }));
    } catch (error) {
      console.error("Error buscando áreas:", error);
    }
  };

const handleAddCategory = () => {
  const existingColumns = chartData.areas.map(a => a.x_position).sort((a, b) => a - b);
  const nextColumn = existingColumns.length > 0 ? Math.max(...existingColumns) + 1 : 1;
  
  const newArea = {
    x_position: nextColumn,
    name: '',
    changeStatus: true,
    isNew: true 
  };
  
  setChartData(prev => ({
    ...prev,
    areas: [...prev.areas, newArea]
  }));
  
  setNewCategories(prev => [...prev, nextColumn]);

  setAreaSuggestions(prev => ({
    ...prev,
    [nextColumn]: []
  }));
};

  const showBuyersSection = () => {
    setActiveSection('buyers');
  };

  const showBuyersGroupSection = () => {
    setActiveSection('buyersList');
  };

  const searchUsers = async (query, formKey) => {
    try {
      const response = await getUsers(3);
      
      const existingUserIds = chartData.users.map(u => u.id);

      const selectedUserIds = Object.entries(newUser)
        .filter(([key]) => key !== formKey) 
        .map(([_, userData]) => userData?.id)
        .filter(Boolean); 
      
      const editingUserIds = editedUsers
        .filter(u => u.id && !u.deletedUser && !existingUserIds.includes(u.id))
        .map(u => u.id);

      const allExcludedIds = [...existingUserIds, ...selectedUserIds, ...editingUserIds];
      
      const filtered = response.data.filter(user => 
        user.role?.id === 3 && 
        !allExcludedIds.includes(user.id) && 
        user.name.toLowerCase().includes(query.toLowerCase())
      );
      
      setUserSuggestions(prev => ({ 
        ...prev, 
        [formKey]: filtered
      }));
      } catch (error) {
      console.error("Error buscando usuarios:", error);
    }
  };

const handleDeleteColumn = (xPosition) => {
  const areaToDelete = chartData.areas.find(area => area.x_position === xPosition);
  
  if (!areaToDelete) return;

  const remainingAreas = chartData.areas
    .filter(area => area.x_position !== xPosition)
    .sort((a, b) => a.x_position - b.x_position);

  const positionMap = {};
  remainingAreas.forEach((area, index) => {
    positionMap[area.x_position] = index + 1;
  });

  const reassignedAreas = remainingAreas.map((area, index) => ({
    ...area,
    x_position: index + 1
  }));

  const reassignedUsers = chartData.users
    .filter(user => user.x_position !== xPosition)
    .map(user => ({
      ...user,
      x_position: positionMap[user.x_position] || user.x_position
    }));

  const reassignedEditedUsers = editedUsers
    .filter(user => user.x_position !== xPosition)
    .map(user => ({
      ...user,
      x_position: positionMap[user.x_position] || user.x_position
    }));

  const updatedActiveForms = activeForms
    .filter(form => form.x !== xPosition)
    .map(form => ({
      ...form,
      x: positionMap[form.x] || form.x
    }));

  const updatedNewUser = {};
  Object.keys(newUser).forEach(key => {
    const [oldX, y] = key.split('-').map(Number);
    if (oldX !== xPosition) {
      const newX = positionMap[oldX] || oldX;
      const newKey = `${newX}-${y}`;
      updatedNewUser[newKey] = newUser[key];
    }
  });

  const updatedUserSuggestions = {};
  Object.keys(userSuggestions).forEach(key => {
    const [oldX, y] = key.split('-').map(Number);
    if (oldX !== xPosition) {
      const newX = positionMap[oldX] || oldX;
      const newKey = `${newX}-${y}`;
      updatedUserSuggestions[newKey] = userSuggestions[key];
    }
  });

  const updatedAreaSuggestions = { ...areaSuggestions };
  delete updatedAreaSuggestions[xPosition];

  setChartData({
    areas: reassignedAreas,
    users: reassignedUsers
  });
  
  setEditedUsers(reassignedEditedUsers);
  setActiveForms(updatedActiveForms);
  setNewUser(updatedNewUser);
  setUserSuggestions(updatedUserSuggestions);
  setNewCategories(prev => prev.filter(col => col !== xPosition));
  setAreaSuggestions(updatedAreaSuggestions);

  if (areaToDelete.isNew) {
    const hasOtherNewCategories = reassignedAreas.some(area => area.isNew === true);
    
    if (hasOtherNewCategories) {
      const filteredOriginalAreas = originalChartData.areas
        .filter(area => area.x_position !== xPosition)
        .map(area => ({
          ...area,
          x_position: positionMap[area.x_position] || area.x_position
        }));

      const filteredOriginalUsers = originalUsers
        .filter(user => user.x_position !== xPosition)
        .map(user => ({
          ...user,
          x_position: positionMap[user.x_position] || user.x_position
        }));

      const filteredOriginalChartUsers = originalChartData.users
        .filter(user => user.x_position !== xPosition)
        .map(user => ({
          ...user,
          x_position: positionMap[user.x_position] || user.x_position
        }));

      setOriginalUsers(filteredOriginalUsers);
      setOriginalChartData({
        areas: filteredOriginalAreas,
        users: filteredOriginalChartUsers
      });
    } else {
      setOriginalUsers(reassignedEditedUsers);
      setOriginalChartData({
        areas: reassignedAreas,
        users: reassignedUsers
      });
    }

  } else {
    const deletedArea = {
      ...areaToDelete,
      changeStatus: false
    };
    setDeletedAreas(prev => [...prev, deletedArea]);
  }
};

  const handleDeleteUser = (userId) => {
    const userToDelete = editedUsers.find(u => u.id === userId);
    
    if (!userToDelete) return;

    const usersBelow = editedUsers
      .filter(u => 
        u.x_position === userToDelete.x_position && 
        u.y_position < userToDelete.y_position &&
        !u.deletedUser
      )
      .sort((a, b) => a.y_position - b.y_position); // Orden ascendente 

    usersBelow.forEach((user, index) => {

    });

    const updatedUsers = editedUsers.map(u => {
      if (u.id === userId) {
        return { ...u, deletedUser: true };
      }
      
      if (u.x_position === userToDelete.x_position && u.y_position < userToDelete.y_position) {
        const newY = u.y_position + 1; // Sube un nivel (-4 → -3, -3 → -2)
        
        return { ...u, y_position: newY };
      }
      
      return u;
    });

    const remainingUsersInColumn = updatedUsers
      .filter(u => 
        u.x_position === userToDelete.x_position && 
        u.y_position <= -2 && 
        !u.deletedUser
      )
      .sort((a, b) => a.y_position - b.y_position);
    
    remainingUsersInColumn.forEach((user, index) => {

    });

    setEditedUsers(updatedUsers);
  };

useEffect(() => {
 if (!loading && chartData.areas.length > 0 && activeSection === 'buyers' && !initialCentered.current) {  
    setTimeout(() => {
      const container = containerRef.current;
      const topScroll = topScrollRef.current;
      
      if (container) {
        const scrollWidth = container.scrollWidth;
        const clientWidth = container.clientWidth;
        
        if (scrollWidth > clientWidth) {
          const centerScroll = (scrollWidth - clientWidth) / 2;
          
          container.scrollLeft = centerScroll;
          
          if (topScroll) {
            topScroll.scrollLeft = centerScroll;
          }
        }
      }
      initialCentered.current = true;
    }, 100); 
  }
}, [loading, chartData.areas, activeSection]);
  
  useEffect(() => {
    if (activeSection === 'buyers') {
      loadChartData();
    }
  }, [activeSection]);

  const fetchChartData = async () => {
    try {
      const response = await getBuyersChart();
    const normalizedUsers = normalizeColumnPositions(response.data.users);
    
    setChartData(response.data);
    setOriginalUsers([...normalizedUsers]);
    setEditedUsers([...normalizedUsers]);
    setOriginalChartData(response.data); 

    setTimeout(() => {
      const container = containerRef.current;
      const topScroll = topScrollRef.current;
      
      if (container) {
        const scrollWidth = container.scrollWidth;
        const clientWidth = container.clientWidth;
        
        if (scrollWidth > clientWidth) {
          const centerScroll = (scrollWidth - clientWidth) / 2;
          container.scrollLeft = centerScroll;
          
          if (topScroll) {
            topScroll.scrollLeft = centerScroll;
          }
        }
      }
    }, 150);
    } catch (error) {
      console.error("Error fetching chart data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUserChange = (updatedUser) => {
    const index = editedUsers.findIndex(u => u.id === updatedUser.id);
    if (index !== -1) {
      const newUsers = [...editedUsers];
      newUsers[index] = updatedUser;
      setEditedUsers(newUsers);
    }
  };

const loadChartData = async () => {
  try {
    setLoading(true);
    const response = await getBuyersChart();
    console.log('Datos cargados:', response.data);
    
    const normalizedUsers = normalizeColumnPositions(response.data.users);
    
    setChartData(response.data);
    setOriginalUsers([...normalizedUsers]);
    setEditedUsers([...normalizedUsers]);
    setOriginalChartData(response.data);
    
    setTimeout(() => {
      const container = containerRef.current;
      const topScroll = topScrollRef.current;
      
      if (container) {
        const scrollWidth = container.scrollWidth;
        const clientWidth = container.clientWidth;
        
        if (scrollWidth > clientWidth) {
          const centerScroll = (scrollWidth - clientWidth) / 2;
          container.scrollLeft = centerScroll;
          
          if (topScroll) {
            topScroll.scrollLeft = centerScroll;
          }
        }
      }
    }, 150);
  } catch (error) {
    console.error("Error fetching chart data:", error);
  } finally {
    setLoading(false);
  }
};

  const handleSave = async () => {
    try {

      const emptyCategories = chartData.areas.filter(area => !area.name?.trim());

      const emptyForms = activeForms.filter(form => {
        const key = `${form.x}-${form.y}`;
        const userData = newUser[key];

        if (!userData) return true;
        
        const name = userData.name?.trim() || '';
        const email = userData.email?.trim() || '';
        const charge = userData.charge?.trim() || '';
        const phone = userData.contact_number?.toString().trim() || '';
        
        return !name && !email && !charge && !phone;

      });

      let errorMessage = '';

      if (emptyCategories.length > 0 && emptyForms.length > 0) {
        errorMessage = "Hay categorías sin nombre y formularios con campos vacíos. Por favor, asigne un nombre a todas las categorías y complete los campos en los formularios.";
      } else if (emptyCategories.length > 0) {
        errorMessage = "Hay categorías sin nombre. Por favor, asigne un nombre a todas las categorías.";
      } else if (emptyForms.length > 0) {
        errorMessage = "Hay formularios con campos vacíos. Por favor, complete los campos.";
      }

      if (errorMessage) {
        setWarningMessage(errorMessage);
        setShowAreaWarning(true);
        return;
      }
      
      setIsSending(true);

      const allUsers = [
        ...editedUsers,
        ...activeForms.map(form => {
          const key = `${form.x}-${form.y}`; 
          return {
            ...newUser[key], 
            x_position: form.x,
            y_position: form.y,
            deletedUser: false,
            visibility_email: newUser[key]?.visibility_email ?? true,
            visibility_contact_number: newUser[key]?.visibility_contact_number ?? true,
            record_visibility: newUser[key]?.record_visibility ?? true
          };
        })
      ];

      const newUsers = allUsers.filter(user => !user.id);
      
      if (newUsers.length > 0) {
        newUsers.forEach((user, index) => {

        });
      } else {
      }

      const areasData = [
        ...chartData.areas.map(area => ({
          id: area.id,
          name: area.name,
          x_position: area.x_position,
          changeStatus: true
        })),
        ...deletedAreas.map(area => ({
          id: area.id,
          name: area.name,
          x_position: area.x_position,
          changeStatus: false
        }))
      ];


      const areaXToIdMap = {};
      chartData.areas.forEach(area => {
        areaXToIdMap[area.x_position] = area.id;
      });

      const deletedExistingAreas = deletedAreas.filter(area => area.id);


      const data = {
          users: allUsers.map(user => {
            if (user.deletedUser) {
              return { 
                id: user.id,
                deletedUser: true 
              };
            }
            
            let processedImage = user.image || null;
            
            if (user.image && user.image.startsWith('http')) {
              processedImage = null; 
            }
            else if (user.image && user.image.startsWith('http')) {
              processedImage = null;
            }

    const originalUser = originalUsers.find(u => u.id === user.id);
    
        const contactNumberValue = user.contact_number;
        const processedContactNumber = contactNumberValue && contactNumberValue !== "" 
          ? Number(contactNumberValue) 
          : null;

    const userData = {
      id: user.id || null,
      name: user.name,
      email: user.email,
      image: processedImage,
      contact_number: processedContactNumber,
      charge: user.charge,
      x_position: user.x_position,
      y_position: user.y_position,
      visibility_email: user.visibility_email ?? true,
      visibility_contact_number: user.visibility_contact_number ?? true
    };

    if (originalUser && originalUser.record_visibility !== user.record_visibility) {
      userData.record_visibility = user.record_visibility ?? true;
    } else if (!originalUser) {
      if (user.record_visibility !== undefined) {
        userData.record_visibility = user.record_visibility;
      }
    }
    return userData;


          }),
          areas: [
            ...chartData.areas.map(area => ({
              id: area.id,
              name: area.name,
              x_position: area.x_position,
              changeStatus: true
            })),
            ...deletedExistingAreas.map(area => ({
              id: area.id,
              name: area.name,
              x_position: area.x_position,
              changeStatus: false
            }))
          ]
      };
      const response = await postBuyersChart(data);
        
      if (response.status === 200) {
        setSuccessMessage("Los cambios se han guardado correctamente");
        setShowSuccessModal(true);

        setDeletedAreas([]);
        setActiveForms([]);
        setNewUser({});
        setUserSuggestions({});
        setNewCategories([]);

        await loadChartData();

        setResetEditingFlag(true);
        setTimeout(() => setResetEditingFlag(false), 0);

        initialCentered.current = false;
          
      } else {
          console.error("Error al guardar:", response.message);
      }

    } catch (error) {
    console.error("Error en la solicitud:", error);

    let errorMessage = "Error al guardar los cambios";
    
    if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
      
      if (errorMessage.includes("El campo 'email' es obligatorio")) {
        errorMessage = "El correo electrónico es obligatorio";
      } else if (errorMessage.includes("El campo 'name' es obligatorio")) {
        errorMessage = "El nombre es obligatorio";
      } else if (errorMessage.includes("El correo electrónico es obligatorio")) {
        errorMessage = "El correo electrónico es obligatorio";
      } else if (errorMessage.includes("El nombre es obligatorio")) {
        errorMessage = "El nombre es obligatorio";
      } else if (errorMessage.includes("El correo electrónico no tiene un formato válido")) {
        errorMessage = "El correo electrónico no tiene un formato válido";
      } else if (errorMessage.includes("El número de contacto debe tener exactamente 9 dígitos numéricos")) {
        errorMessage = "El número de contacto debe tener exactamente 9 dígitos numéricos";
      } 
    } else if (error.message) {
      errorMessage = error.message;
    }
    
    setWarningMessage(errorMessage);
    setShowAreaWarning(true);
    } finally {
      setIsSending(false);
    }
  };

  const handleCancel = () => {
    setEditedUsers([...originalUsers]);
    setChartData({...originalChartData}); 
    setDeletedAreas([]); 
    setActiveForms([]);
    setNewUser({});
    setNewCategories([]);
    setShowDeleteModal(false);

  setAreaSuggestions({});
  
  setUserSuggestions({});

  setResetEditingFlag(true);
  setTimeout(() => setResetEditingFlag(false), 0);
  };

  const handleImageError = (message) => {
    setImageErrorMessage(message);
    setShowImageError(true);
  };

  const closeImageError = () => {
    setShowImageError(false);
    setImageErrorMessage('');
  };

  const renderChart = () => {
    const visibleAreas = chartData.areas.filter(area => area.changeStatus !== false);
    const visibleUsers = editedUsers.filter(user => !user.deletedUser);

    const usersByColumn = {};
    visibleUsers.forEach(user => {
      const col = user.x_position;
      if (!usersByColumn[col]) usersByColumn[col] = {};
      if (!usersByColumn[col][user.y_position]) usersByColumn[col][user.y_position] = [];
      usersByColumn[col][user.y_position].push(user);
    });

    // Calcular columna central
    const centerCol = visibleAreas.length > 0 
      ? visibleAreas.reduce((sum, a) => sum + a.x_position, 0) / visibleAreas.length
      : 0;

    // Encontrar la posición Y mínima (más negativa) por columna
    const minYByColumn = {};
    visibleUsers.forEach(user => {
      if (user.y_position <= -2) {
        const col = user.x_position;
        if (!minYByColumn[col] || user.y_position < minYByColumn[col]) {
          minYByColumn[col] = user.y_position;
        }
      }
    });

    // Obtener todas las columnas existentes
    const existingColumns = chartData.areas.map(a => a.x_position).sort((a, b) => a - b);
    // Agregar columna fantasma (última posición + 1)
    const nextColumn = existingColumns.length > 0 ? Math.max(...existingColumns) + 1 : 1;
    const lastRealCol = existingColumns.length > 0 ? Math.max(...existingColumns) : 0;
    const allColumns = [
      ...existingColumns,
      ...Array.from({ length: phantomColumns }, (_, i) => lastRealCol + i + 1)
    ];

    const allLevelsSet = new Set([
      ...visibleUsers.map(u => u.y_position),
      ...activeForms.map(f => f.y)
    ]);

    chartData.areas.forEach(area => {
      const col = area.x_position;
      const usersInCol = visibleUsers.filter(u => u.x_position === col && u.y_position <= -2);
      const formsInCol = activeForms.filter(f => f.x === col && f.y <= -2);
      const allY = [...usersInCol.map(u => u.y_position), ...formsInCol.map(f => f.y)];
      const minY = allY.length ? Math.min(...allY) : -2;
      const nextY = minY - 1;
      allLevelsSet.add(nextY);
    });

    // Asegurarnos de que al menos haya un nivel para cada columna existente
    chartData.areas.forEach(area => {
      const col = area.x_position;
      if (!minYByColumn[col]) {
        allLevelsSet.add(-2); // Nivel base para columnas sin usuarios
      }
    });

    const allLevels = Array.from(allLevelsSet).sort((a, b) => b - a);

    return (
<DndContext 
  sensors={sensors}
  collisionDetection={closestCenter}
  onDragStart={handleDragStart}
  onDragEnd={handleDragEnd}
  onDragOver={handleDragOver}
  onDragCancel={() => {
    setIsDragging(false);
    document.body.style.cursor = '';
    document.body.style.userSelect = '';
  }}
>
  <style>{styles}</style>
  <div className="relative flex flex-col w-full">

          <div 
            ref={topScrollRef}
            className="w-full overflow-x-auto overflow-y-hidden organigrama-container-top"
            onScroll={handleTopScroll}
          >
            <div 
              className="h-[6px]" 
              style={{ 
                width: containerRef.current ? `${containerRef.current.scrollWidth}px` : '100%',
                minWidth: '100%',
                pointerEvents: 'none'
              }}
            />
          </div>
  
            <div
              ref={containerRef}
              onScroll={handleScroll}
              className="relative flex flex-col w-full overflow-x-auto organigrama-container">
              <div className="flex flex-col min-w-max"> 
                {allLevels.map((yLevel) => {
                  const getColumnsForLevel = (yLevel) => {
                    if (yLevel <= -2) {
                      return allColumns;
                    } else {
                      return [centerCol];
                    }
                  };
  
                  const columnsToUse = getColumnsForLevel(yLevel);
  
                  return (
                    <React.Fragment key={yLevel}>
                      <div className={`relative flex justify-center h-auto w-full`}>
                        {columnsToUse.map((col, colIndex) => {
                          const isGhostColumn = col === nextColumn;
                          const areaExists = chartData.areas.some(a => a.x_position === col);
                          const area = chartData.areas.find(a => a.x_position === col);
                          const areaName = area?.name || '';
                          
                          const usersInCell = visibleUsers.filter(
                            u => u.y_position === yLevel && (
                              (yLevel <= -2 && u.x_position === col) ||
                              (yLevel >= -1 && col === centerCol)
                          ));
  
                          const columnLevels = !isGhostColumn ? Object.keys(usersByColumn[col] || {}).map(Number).sort((a, b) => b - a) : [];
                          const isLastInColumn = !isGhostColumn && yLevel === Math.min(...columnLevels);
                          const showLine = yLevel <= -2 && !isGhostColumn && areaExists;
                          const totalColumns = visibleAreas.length + phantomColumns;
  
                          return (
                            <div
                              key={colIndex}
                              className="relative flex-shrink-0 drop-zone"
                              style={{ width: "342px" }}
                              data-column={col}
                            >
                            {isGhostColumn && yLevel === -2 && (
                              <>
  
                                  <div className="flex flex-col items-center justify-start h-[350px] w-full ">
                                    <button 
                                      onClick={handleAddCategory}
                                      className="flex flex-col items-center justify-center py-4"
                                    >
                                      <svg width="87" height="87" viewBox="0 0 87 87" fill="none">
                                        <path d="M37.334 49.3334H6.50067C4.75345 49.3334 3.2899 48.7414 2.11001 47.5574C0.930117 46.3734 0.338117 44.9098 0.334006 43.1667C0.329895 41.4236 0.921895 39.96 2.11001 38.776C3.29812 37.592 4.76167 37 6.50067 37H37.334V6.16669C37.334 4.41947 37.926 2.95591 39.11 1.77602C40.294 0.596133 41.7576 0.00413238 43.5007 2.12643e-05C45.2438 -0.00408985 46.7094 0.587911 47.8975 1.77602C49.0856 2.96413 49.6756 4.42769 49.6673 6.16669V37H80.5007C82.2479 37 83.7135 37.592 84.8975 38.776C86.0815 39.96 86.6714 41.4236 86.6673 43.1667C86.6632 44.9098 86.0712 46.3754 84.8913 47.5635C83.7114 48.7516 82.2479 49.3416 80.5007 49.3334H49.6673V80.1667C49.6673 81.9139 49.0753 83.3795 47.8913 84.5635C46.7073 85.7475 45.2438 86.3375 43.5007 86.3334C41.7576 86.3292 40.294 85.7372 39.11 84.5574C37.926 83.3775 37.334 81.9139 37.334 80.1667V49.3334Z" fill="#184A7D"/>
                                      </svg>
                                      <p className="text-[#184A7D] text-[18px] font-itcdemi mt-2">Agregar categoría</p>
                                    </button>
                                  </div>
                                
                              </>
                            )}
  
                              {/* Mostrar área y líneas para columnas existentes */}
                              {!isGhostColumn && areaExists && yLevel === -2 ?  (
                                <>
                                  {/* Bloque de Categoría */}
                                  <div className="absolute left-0 z-10 w-full p-2 -top-24">
                                    <div className="flex flex-col gap-2">
                                      <p className="font-itcbook text-[15px]">Categoría: <span className="text-red-500">*</span></p>
                                      <div className="flex items-end gap-2">
                                        <div className="relative z-10 w-full">
                                          <input
                                            type="text"
                                            value={areaName}
                                            onChange={(e) => {
                                              const sanitizedValue = e.target.value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s]/g, '');
                                              const updatedAreas = chartData.areas.map(a => 
                                                a.x_position === col ? {...a, name: sanitizedValue} : a
                                              );
                                              setChartData({...chartData, areas: updatedAreas});
                                              if(sanitizedValue.length > 0) {
                                                searchAreas(sanitizedValue, col);
                                              } else {
                                                setAreaSuggestions(prev => ({ ...prev, [col]: [] }));
                                              }
                                            }}
                                            onKeyDown={(e) => {
                                              const invalidChars = /[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s]/;
                                              if (invalidChars.test(e.key)) {
                                                e.preventDefault();
                                              }
                                            }}
                                            className="rounded-lg h-[38px] outline-none w-full border-[1px] border-[#D1D5DB] bg-white p-2 font-itcbook text-base"
                                            placeholder="Escribir categoría"
                                          />
                                          {/* Mostrar sugerencias */}
                                          {areaSuggestions[col]?.length  > 0 && (
                                            <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg">
                                              {areaSuggestions[col].map((area, index) => (
                                                <div
                                                  key={index}
                                                  className="p-2 cursor-pointer hover:bg-gray-100"
                                                  onClick={() => handleAreaSelection(col, area) }
                                                >
                                                  {area.name}
                                                </div>
                                              ))}
                                            </div>
                                          )}
                                        </div>
                                        <button
                                          onClick={() => handleDeleteColumn(col)}
                                          className="border-[1px] flex justify-center items-center h-[34px] border-[#D1D5DB] rounded-[4px] bg-white w-[34px]">
                                          <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M2.25 4.25L3.1875 19.25C3.23203 20.1167 3.8625 20.75 4.6875 20.75H13.3125C14.1408 20.75 14.7595 20.1167 14.8125 19.25L15.75 4.25" stroke="#EB445A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M0.75 4.25H17.25H0.75Z" fill="#EB445A"/><path d="M0.75 4.25H17.25" stroke="#EB445A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/><path d="M6 4.25V2.375C5.99957 2.22715 6.02837 2.08066 6.08475 1.94397C6.14114 1.80729 6.22399 1.6831 6.32854 1.57854C6.43309 1.47399 6.55728 1.39114 6.69397 1.33476C6.83066 1.27838 6.97714 1.24957 7.125 1.25H10.875C11.0229 1.24957 11.1693 1.27838 11.306 1.33476C11.4427 1.39114 11.5669 1.47399 11.6715 1.57854C11.776 1.6831 11.8589 1.80729 11.9152 1.94397C11.9716 2.08066 12.0004 2.22715 12 2.375V4.25M9 7.25001V17.75M5.625 7.25001L6 17.75M12.375 7.25001L12 17.75" stroke="#EB445A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              ) : null }
                                {isDragging && dragOverInfo.column === col && dragOverInfo.position === yLevel && (
                                <div className="absolute top-0 z-50 w-full h-1 bg-blue-500 drop-preview"></div>
                              )}
  
                              {/* Mostrar usuarios existentes */}
                              {!isGhostColumn && usersInCell.map(user => (
                                <SortableContext 
                                  items={usersInCell.map(u => u.id)}
                                  strategy={verticalListSortingStrategy}
                                >
                                  <div key={user.id} className="relative" data-id={user.id}>
                                    {/* Línea vertical a la izquierda */}
                                    {showLine && (
                                      <div
                                        className={`absolute top-0 ${isLastInColumn ? 'h-1/2' : 'h-full'} w-[2px] bg-blue`}
                                      />
                                    )}
  
                                    {/* Línea horizontal desde tercera fila */}
                                    {yLevel <= -2 && (
                                      <div className="absolute w-[34px] h-[2px] bg-blue left-0 top-1/2" />
                                    )}
  
                                    {/* Rayita arriba en tercera fila */}
                                    {yLevel === -2 && (
                                      <div className="flex items-center justify-center">
                                        <div className="bg-blue h-[34px] w-[2px]"></div>
                                      </div>
                                    )}
  
                                    {/* Card */}
                                    <BuyerCardAdmin
                                      key={user.id}
                                      id={user.id}
                                      user={user}
                                      y_position={user.y_position}
                                      onUserChange={handleUserChange}
                                      onDelete={(userId) => {
                                        setUserToDelete(userId);
                                        setShowDeleteModal(true);
                                      }}
                                      height={user.y_position === 0 || user.y_position === -1 ? "h-[235px]" : "h-[350px]"} 
                                      pt={false}
                                      searchUsers={searchUsers}
                                      userSuggestions={userSuggestions}
                                      setUserSuggestions={setUserSuggestions}
                                      options={user.y_position === 0 || user.y_position === -1 ? "bottom-24" : "bottom-12"} 
                                      resetEditing={resetEditingFlag}
                                      onImageError={handleImageError} 
                                    />
  
                                    {/* Línea debajo de primeras filas */}
                                    {yLevel >= -1 && (
                                      <div className="flex items-center justify-center">
                                        <div className={`bg-blue h-28 w-[2px] ${totalColumns % 2 === 0 ? 'ml-[2px]' : ''}`}></div>
                                      </div>
                                    )}
  
                                    {/* Línea horizontal divisoria después de fila 2 */}
                                    {yLevel === -2 && (
                                      <div 
                                        className="bg-blue absolute top-0 h-[2px]" 
                                        style={{
                                          width: "100%",
                                          left: colIndex === columnsToUse.length - 1 ? "0" : ""
                                        }}
                                      />
                                    )}
                                  </div>
                                </SortableContext>
                              ))}
  
                              {/* Mostrar botón "Agregar fila" o formulario */}
                              {!isGhostColumn && (() => {
                                const usersInColumn = visibleUsers.filter(u => u.x_position === col && u.y_position <= -2);
                                const formsInColumn = activeForms.filter(f => f.x === col && f.y <= -2);
                                const allY = [
                                  ...usersInColumn.map(u => u.y_position),
                                  ...formsInColumn.map(f => f.y),
                                ];
                                const minY = allY.length ? Math.min(...allY) : -2;
                                const nextY = allY.length === 0 ? -2 : minY - 1;
  
                                const formExists = activeForms.some(f => f.x === col && f.y === yLevel);
                                const columnIsEmpty = usersInColumn.length === 0;
                                const isFirstAddButton = yLevel === -2 && columnIsEmpty; 
                                const isFormAtTopLevel = formExists && yLevel === -2; 
  
                                if  (yLevel === nextY || formExists) {
                                  const form = activeForms.find(f => f.x === col && f.y === yLevel);
  
                                  return (
                                    <div className="relative">
                                      {(isFirstAddButton && !form) || isFormAtTopLevel ? (
                                        <>
                                          {/* Línea vertical a la izquierda - solo para el primer botón */}
                                          {isFirstAddButton && !form && (
                                            <div className="absolute top-0 h-1/2 w-[2px] bg-blue" />
                                          )}
                                          
                                          {/* Línea horizontal desde tercera fila - solo para el primer botón */}
                                          {isFirstAddButton && !form && (
                                            <div className="absolute w-[34px] h-[2px] bg-blue left-0 top-1/2" />
                                          )}
                                          
                                          {/* Rayita arriba en tercera fila - solo para el primer botón */}
                                          {isFirstAddButton && !form && (
                                            <div className="flex items-center justify-center">
                                              <div className="bg-blue h-[34px] w-[2px]"></div>
                                            </div>
                                          )}
  
                                          {/* Línea horizontal superior - para ambos casos */}
                                          <div 
                                            className="bg-blue absolute top-0 h-[2px]" 
                                            style={{
                                              width: "100%",
                                              left: colIndex === columnsToUse.length - 1 ? "0" : ""
                                            }}
                                          />
                                        </>
                                      ) : null}
                                      {form ? (
                                        <BuyerForm
                                          form={form}
                                          newUser={newUser}
                                          setNewUser={setNewUser}
                                          userSuggestions={userSuggestions}
                                          searchUsers={searchUsers}
                                          setUserSuggestions={setUserSuggestions}
                                          onImageError={handleImageError} 
                                        />
                                      ) : (
                                        <div className="flex flex-col items-center justify-start h-[350px] w-full p-4">
                                          <button 
                                            onClick={() => {
                                              const alreadyExists = activeForms.some(f => f.x === col && f.y === nextY);
                                              if (!alreadyExists) {
                                                setActiveForms(prev => [...prev, { x: col, y: nextY }]);
                                              }
                                            }}
                                            className="flex flex-col items-center justify-center py-4"
                                          >
                                            <svg width="87" height="87" viewBox="0 0 87 87" fill="none">
                                              <path d="M37.334 49.3334H6.50067C4.75345 49.3334 3.2899 48.7414 2.11001 47.5574C0.930117 46.3734 0.338117 44.9098 0.334006 43.1667C0.329895 41.4236 0.921895 39.96 2.11001 38.776C3.29812 37.592 4.76167 37 6.50067 37H37.334V6.16669C37.334 4.41947 37.926 2.95591 39.11 1.77602C40.294 0.596133 41.7576 0.00413238 43.5007 2.12643e-05C45.2438 -0.00408985 46.7094 0.587911 47.8975 1.77602C49.0856 2.96413 49.6756 4.42769 49.6673 6.16669V37H80.5007C82.2479 37 83.7135 37.592 84.8975 38.776C86.0815 39.96 86.6714 41.4236 86.6673 43.1667C86.6632 44.9098 86.0712 46.3754 84.8913 47.5635C83.7114 48.7516 82.2479 49.3416 80.5007 49.3334H49.6673V80.1667C49.6673 81.9139 49.0753 83.3795 47.8913 84.5635C46.7073 85.7475 45.2438 86.3375 43.5007 86.3334C41.7576 86.3292 40.294 85.7372 39.11 84.5574C37.926 83.3775 37.334 81.9139 37.334 80.1667V49.3334Z" fill="#184A7D"/>
                                            </svg>
                                            <p className="text-[#184A7D] text-[18px] font-itcdemi mt-2">Agregar</p>
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                  );
                                }
  
                                return null;
                              })()}
                            </div>
                          );
                        })}
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>
            </div>
            {isDragging && (
              <div className="fixed bottom-10 left-1/2 transform -translate-x-1/2 bg-blue text-white px-4 py-2 rounded-lg shadow-lg z-[9999] flex items-center gap-2">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 21.2852C3.71667 21.2852 3.47933 21.1892 3.288 20.9972C3.09667 20.8052 3.00067 20.5678 3 20.2852V17.8602C3 17.5935 3.05 17.3392 3.15 17.0972C3.25 16.8552 3.39167 16.6428 3.575 16.4602L16.2 3.86016C16.4 3.67682 16.621 3.53516 16.863 3.43516C17.105 3.33516 17.359 3.28516 17.625 3.28516C17.891 3.28516 18.1493 3.33516 18.4 3.43516C18.6507 3.53516 18.8673 3.68516 19.05 3.88516L20.425 5.28516C20.625 5.46849 20.7707 5.68516 20.862 5.93516C20.9533 6.18516 20.9993 6.43516 21 6.68516C21 6.95182 20.954 7.20616 20.862 7.44816C20.77 7.69016 20.6243 7.91082 20.425 8.11016L7.825 20.7102C7.64167 20.8935 7.429 21.0352 7.187 21.1352C6.945 21.2352 6.691 21.2852 6.425 21.2852H4ZM17.6 8.08516L19 6.68516L17.6 5.28516L16.2 6.68516L17.6 8.08516Z" fill="white"/>
                </svg>
                {dragPosition ? 
                  `Moviendo a: Columna ${dragPosition.x}, Posición ${dragPosition.y}` : 
                  "Arrastrando..."}
              </div>
            )}
            {dragOverInfo.column !== null && (
              <div className="fixed bottom-10 left-1/2 transform -translate-x-1/2 bg-blue text-white px-4 py-2 rounded-lg shadow-lg z-[9999] flex items-center gap-2">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 21.2852C3.71667 21.2852 3.47933 21.1892 3.288 20.9972C3.09667 20.8052 3.00067 20.5678 3 20.2852V17.8602C3 17.5935 3.05 17.3392 3.15 17.0972C3.25 16.8552 3.39167 16.6428 3.575 16.4602L16.2 3.86016C16.4 3.67682 16.621 3.53516 16.863 3.43516C17.105 3.33516 17.359 3.28516 17.625 3.28516C17.891 3.28516 18.1493 3.33516 18.4 3.43516C18.6507 3.53516 18.8673 3.68516 19.05 3.88516L20.425 5.28516C20.625 5.46849 20.7707 5.68516 20.862 5.93516C20.9533 6.18516 20.9993 6.43516 21 6.68516C21 6.95182 20.954 7.20616 20.862 7.44816C20.77 7.69016 20.6243 7.91082 20.425 8.11016L7.825 20.7102C7.64167 20.8935 7.429 21.0352 7.187 21.1352C6.945 21.2352 6.691 21.2852 6.425 21.2852H4ZM17.6 8.08516L19 6.68516L17.6 5.28516L16.2 6.68516L17.6 8.08516Z" fill="white"/>
                </svg>
                Moviendo a: Columna {dragOverInfo.column}, Posición {dragOverInfo.position}
              </div>
            )}
</div>
        </DndContext>
    );
  };
const hasChanges = () => {

  const usersChanged = JSON.stringify(editedUsers) !== JSON.stringify(originalUsers);
  
  const areasChanged = JSON.stringify(chartData.areas) !== JSON.stringify(originalChartData.areas) || 
                      deletedAreas.length > 0;

  const hasNewCategories = chartData.areas.some(area => 
    area.isNew === true && 
    area.name?.trim() &&
    !originalChartData.areas.some(origArea => origArea.x_position === area.x_position)
  );

  const hasAreaNameChanges = chartData.areas.some(area => {
    const originalArea = originalChartData.areas.find(orig => orig.id === area.id);
    return originalArea && originalArea.name !== area.name;
  });

  const hasNewUsers = editedUsers.some(user => !user.id && !user.deletedUser);

  const hasActiveForms = activeForms.length > 0;

  const hasValidChanges = usersChanged || 
                         areasChanged || 
                         hasNewCategories || 
                         hasNewUsers ||
                         hasAreaNameChanges ||
                         hasActiveForms; 

  return hasValidChanges;
};



  return (
    <div >
      <Menu isMenuOpen={isMenuOpen} toggleMenu={() => setIsMenuOpen(!isMenuOpen)} />
      <div className={`flex-1 transition-all duration-300 pt-[67px] bg-[#F7F8F9] w-full z-50 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"} `}>
        <div className="sm:pt-8 pt-6 pb-10 px-[5%] sm:px-[3%]">
          <div className="flex flex-col gap-3">
            <div className="flex items-center justify-between gap-4">
              <h1 className="md:text-[32px] text-2xl text-blue font-itcbold">
                {activeSection === 'buyers' ? 'Compradores' : 'Grupos de compra'}
              </h1>
              <div className="flex items-center justify-between gap-8">
                <button onClick={showBuyersSection}>
                  <img 
                    src={buyers}
                    alt="Organigrama"
                    className={activeSection === 'buyers' ? "" : "opacity-30"}
                  />
               </button>
               <button onClick={showBuyersGroupSection}>
                  <img 
                    src={buyersList}
                    alt="Grupos de compra"
                    className={activeSection === 'buyersList' ? "" : "opacity-30"}
                  />
                </button>
              </div>
            </div>

            {activeSection === 'buyers' ? (
            <>
              {renderChart()}
              <div className="flex items-center justify-center">
                <div className="flex w-full lg:w-[90%] sm:w-[65%] pt-10 gap-7 items-center justify-center">
                  <SaveButton
                    title={isSending ? "Guardando..." : "Guardar"}
                    onClick={handleSave}
                    disabled={!hasChanges() || isSending}
                    bg={hasChanges() ? "bg-green" : "bg-gray"}
                  />
                  <CancelButton 
                    onClick={handleCancel}
                    disabled={false}
                    border="border-green"
                  />
                </div>
              </div>
            </>
            ) : (
              <BuyersGroup />
            )}
          </div>
        </div>
      </div>

      <ModalDelete 
        showModalDelete={showDeleteModal}
        closeModal={() => setShowDeleteModal(false)}
        accept={() => {
          handleDeleteUser(userToDelete);
          setShowDeleteModal(false);
        }}
        textType="comprador"
      />
      <ModalAlertWarning 
        showModalAlertWarning={showAreaWarning}
        closeModal={() => setShowAreaWarning(false)}
        error={warningMessage}
        accept={() => setShowAreaWarning(false)}
      />
      <ModalAlertWarning 
        showModalAlertWarning={showImageError}
        closeModal={closeImageError}
        error={imageErrorMessage}
        accept={closeImageError}
      />
      <ModalSuccess 
        showModalSuccess={showSuccessModal}
        closeModalSuccess={() => {
        setShowSuccessModal(false);
        }}
        fill="green"
        text={successMessage}
      />
    </div>
  );
}